import styled from "styled-components";

import { FlexContainer, FlexDiv, FlexSection } from "../../../components/Atoms";

export const Wrapper = styled(FlexSection)`
  padding: 48px 0 88px;
  background-color: ${({ theme }) => theme.colorsV2.shyft.cream};
  @media only screen and (max-width: 767px) {
    padding: 40px 0 32px;
  }
`;

export const Div = styled(FlexDiv)`
  width: 100%;
`;

export const WebinarList = styled(FlexDiv)`
  margin: 0 -8px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    margin: 0;
    padding: 0;
  }
`;

export const Container = styled(FlexContainer)``;
